import FilterToolbarForm from "./FilterToolbarForm";
import {
  reducer,
  mapStateToProps,
  mapDispatchToProps,
} from "./FilterToolbarForm.state";

FilterToolbarForm.reducer = reducer;
FilterToolbarForm.mapStateToProps = mapStateToProps;
FilterToolbarForm.mapDispatchToProps = mapDispatchToProps;

export default FilterToolbarForm;
